export const createExcelExportWorker = () =>
  new Worker(new URL('../workers/excelExportWorker.ts', import.meta.url), {
    type: 'module',
  });
